import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { AuthGuard } from "@main-services/auth-guard.service";
import { ROUTER_OUTLET_NAME } from "@modules/+new/shared/universal-modal/entities/magic";
import { VerifiedUserGuard } from "@modules/+new/payments/shared-payments/components/user-verification/infrastructure/verified-user-guard.service";

const routes: Routes = [
	{
		outlet: ROUTER_OUTLET_NAME,
		path: "fiat-deposit",
		loadChildren: () =>
			import("@modules/+new/payments/features/fiat-deposit/fiat-deposit-routing.module").then(
				(m) => m.FiatDepositModalRoutingModule
			),
		canActivate: [AuthGuard, VerifiedUserGuard]
	},
	{
		outlet: ROUTER_OUTLET_NAME,
		path: "payments",
		loadChildren: () =>
			import("@modules/+new/payments/shared-payments/shared-payment-routing.module").then(
				(m) => m.SharedPaymentRoutingModule
			),
		canActivate: [AuthGuard]
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)]
})
export class PaymentsEntryModule {}
